import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from '../services/store/auth-store.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthStoreService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true; 
  }

  router.navigate(['/login']);
};

